module.exports = __webpack_public_path__ + "img/no-photo.092c702e.png";